//import Message from "../../models/Message";
import axios from "axios";
import { API_BASE_URL, FETCH_LIMIT } from "./../../globalVars";

export default {
  namespaced: true,

  actions: {
    async hydrate({ commit }, lastUpdateTime = null) {
      const store = this;
      const last = this.getters["entities/settings/query"]().first()
        .lastUpdateFromServer;
      await fetchNext({
        store: store,
        offset: 0,
        lastDateTime: lastUpdateTime ? lastUpdateTime : last
      });
    },

    async fetchMessage(context, { accountId, messageId }) {
      let store = this;
      try {
        let response = await axios({
          method: "get",
          url: API_BASE_URL + `/message`,
          params: {
            accountId: accountId,
            id: messageId
          },
          headers: {
            Authorization: `Bearer ${localStorage.getItem("access_token")}`
          }
        });
        store.dispatch("entities/messages/insert", {
          data: response.data.data
        });
        store.dispatch("entities/settings/setIsOffline", false);
      } catch (error) {
        store.dispatch("entities/settings/setIsOffline", true);
      }
    },

    // async fetchLatestMessages(context, { isInbound }) {
    //   let store = this;
    //   try {
    //     let response = await axios({
    //       method: "get",
    //       url: API_BASE_URL + `/message`,
    //       params: {
    //         latest: true,
    //         isInbound: isInbound
    //       },
    //       headers: {
    //         Authorization: `Bearer ${localStorage.getItem("access_token")}`
    //       }
    //     });
    //     store.dispatch("entities/customers/insert", {
    //       data: response.data
    //     });
    //     store.dispatch("entities/settings/setIsOffline", false);
    //   } catch (error) {
    //     store.dispatch("entities/settings/setIsOffline", true);
    //   }
    // },

    async createMessage(context, message) {
      if (message.isDirty === true) {
        const store = this;
        try {
          let response = await axios({
            method: "post",
            url: API_BASE_URL + `/message`,
            data: {
              accountId: message.accountId,
              customerId: message.customerId,
              messageType: message.messageType,
              messageBody: message.messageBody,
              media: message.media,
              isInbound: message.isInbound,
              isReviewRequest: message.isReviewRequest,
              userId: message.userId,
              contactInfoId: message.contactInfoId
            },
            headers: {
              Authorization: `Bearer ${localStorage.getItem("access_token")}`
            }
          });
          store.dispatch("entities/messages/delete", {
            where: message.tempId
          });
          store.dispatch("entities/messages/insert", {
            where: response.id,
            data: response.data
          });
          store.dispatch("entities/settings/setIsOffline", false);
        } catch (error) {
          store.dispatch("entities/settings/setIsOffline", true);
        }
      }
    }
  }
};

async function fetchNext({ store, offset, lastDateTime = 0 }) {
  try {
    let response = await axios({
      method: "get",
      url:
        API_BASE_URL +
        `/message?updatedAt[$gt]=${lastDateTime}&$limit=${FETCH_LIMIT}&$skip=${offset}`,
      headers: {
        Authorization: `Bearer ${localStorage.getItem("access_token")}`
      }
    });
    const obj = response.data.data;
    const maxRows = response.data.total;
    let messages = [];
    obj.forEach(function(message) {
      messages.push({
        id: message.id,
        isDirty: false,
        customerId: message.customerId,
        messageType: message.messageType,
        messageBody: message.messageBody,
        media: message.media,
        isInbound: message.isInbound,
        isReviewRequest: message.isReviewRequest,
        userId: message.userId,
        contactInfoId: message.contactInfoId,
        createdAt: Date.parse(message.createdAt),
        updatedAt: Date.parse(message.updatedAt)
      });
    });
    if (messages.length > 0) {
      store.dispatch("entities/messages/insert", {
        data: messages
      });
    }
    store.dispatch("entities/settings/setIsOffline", false);
    if (maxRows > FETCH_LIMIT + offset) {
      await fetchNext({
        store,
        offset: FETCH_LIMIT + offset,
        lastDateTime
      });
    }
  } catch (error) {
    store.dispatch("entities/settings/setIsOffline", true);
  }
}
